module.exports = __webpack_public_path__ + "img/unknown.b5866c37.png";